import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { selectHasPermission } from '../store/slices/authSlice';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const location = useLocation();
  const { isAuthenticated, initialized } = useSelector((state) => state.auth);

  const hasPermission = useSelector((state) =>
    requiredPermission ? selectHasPermission(state, requiredPermission) : true
  );

  // 1️⃣ Wait until auth state is initialized
  if (!initialized) {
    return (
      <div className="loading-container">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // 2️⃣ Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 3️⃣ Redirect to dashboard if missing permission
  if (requiredPermission && !hasPermission) {
    return (
      <Navigate
        to="/dashboard"
        state={{ error: 'You do not have permission to access this page.' }}
        replace
      />
    );
  }

  // 4️⃣ Otherwise, render children
  return <>{children}</>;
};

export default ProtectedRoute;
